import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import("jspdf-autotable")

function getExportData({ data, exportColumns }) {
  let exportData = data.map((item) => {
    return exportColumns.reduce((result, column) => {
      let value = item[column.uid]
      if (column.hasOwnProperty("type") && column.type === "date") {
        value = new Date(value).toLocaleDateString()
      }
      result[column.name] = value

      return result
    }, {})
  })
  return exportData
}

function convertToNestedArray({ data }) {
  /* convert array of object to array of array */
  const dataArray = data.length > 0 ? data.map(Object.values) : []
  return dataArray
}

function createColumnArray({ data }) {
  const columnArray = data.length > 0 ? Object.keys(data[0]) : []
  return columnArray
}

/* exports */
const exportToExcel = ({ data, downloadFileName, exportColumns }) => {
  const exportData = getExportData({ data, exportColumns })

  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data")
  XLSX.writeFile(workbook, `${downloadFileName}.xlsx`)
}

const exportToCSV = ({ data, downloadFileName, exportColumns }) => {
  const exportData = getExportData({ data, exportColumns })

  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data")
  XLSX.writeFile(workbook, `${downloadFileName}.csv`)
}

const exportToPDF = ({
  data=[],
  downloadFileName="",
  exportColumns = [],
  downloadFileheader = [],
}) => {
  const exportData = getExportData({ data, exportColumns })

  const doc = new jsPDF()

  jsPDF.autoTableSetDefaults({
    headStyles: { fillColor: 0 },
  })

  /* creating column list */
  const colummArray = createColumnArray({ data: exportData })
  /* copy data as array of array */
  const dataArray = convertToNestedArray({ data: exportData })

  doc.setFontSize(16)
  let startY = 10
  let gapY = 10

  doc.text(`${downloadFileName.split("_").join(" ")}`, 12, 10)
  gapY = 20
  startY = 20

  doc.setFontSize(12)
  if (downloadFileheader.length > 0) {
    downloadFileheader.map((item, index) => {
      doc.text(`${item.key}: ${item.value}`, 12, gapY)
      startY += 10
      gapY += 5
      return 0
    })
  }

  doc.autoTable({
    theme: "grid",
    body: dataArray,
    head: [colummArray],
    tableWidth: "wrap",
    startY: startY,
    styles: {
      fontSize: 8,
      cellWidth: 25,
    },
    columnStyles: { text: { cellWidth: "wrap" } },
  })

  doc.save(`${downloadFileName}.pdf`)
}

export { exportToExcel, exportToCSV, exportToPDF }
